import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import previewListModal from './../demageManage/previewListModal.vue';
import previewModal from './../demageManage/previewModal.vue';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { isPDF, isImage, isVideo, getBase64 } from '@/views/claim/demageManage/utils';
import { auditOperate } from '@/views/examine/claimRecordManage/request';
import { claimsVerifyy } from './../../policy/customerManage/request';
import { policyDetail } from '@/views/policy/customerManage/request';
import { plainOptions } from '@/views/claim/demageManage/utils';
import { getCityCode } from '@/utils/validate';
export default {
  components: {
    topTitle,
    areaSelect,
    previewModal,
    previewListModal
  },
  props: {
    claimsInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    auditScheduleId: {
      type: Number,
      default: 0
    },
    policyId: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      plainOptions,
      policyInfo: {},
      additionalShow: false,
      previewListVisible: false,
      action: uploadFile,
      uploadAccept: '',
      fileDialog: false,
      previewVisible: false,
      modalPreviewList: [],
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      currentPreviewIndex: 0,
      isShow: '',
      previewFileList: [],
      additionalFileList: [],
      getCityCode
    };
  },
  mounted() {
    policyDetail({
      policyId: this.policyId
    }).then(res => {
      this.policyInfo = res.policyInfo;
    });
    let arr = this.claimsInfo.claimsDocument.filter(item => item.documentId == 0);
    this.additionalFileList = arr.length != 0 ? arr[0].documentUrl : [];
    if (arr.length != 0) {
      /* eslint-disable */
      this.claimsInfo.claimsDocument.pop();
    }
    this.additionalShow = true;
  },
  methods: {
    clickPlus(index) {
      this.$nextTick(() => {
        if (index !== 'addition') {
          this.toChangeUploadAccept(this.claimsInfo.claimsDocument[index].documentFormat);
        } else {
          this.toChangeUploadAccept(this.plainOptions);
        }
        this.fileDialog = true;
      });
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    removeUploadFile(file, i) {
      if (i || i === 0) {
        const index = this.claimsInfo.claimsDocument[i].documentUrl.indexOf(file);
        const newFileList = this.claimsInfo.claimsDocument[i].documentUrl.slice();
        newFileList.splice(index, 1);
        /* eslint-disable */
        this.claimsInfo.claimsDocument[i].documentUrl = newFileList;
      } else {
        const index = this.additionalFileList.indexOf(file);
        const newFileList = this.additionalFileList.slice();
        newFileList.splice(index, 1);
        this.additionalFileList = newFileList;
      }
    },
    // 点击模板预览
    onModalPreview(index) {
      this.modalPreviewList = this.claimsInfo.claimsDocument[index].documentTemplateUrl.map((item, i) => {
        let obj = {};
        obj.status = 'done';
        obj.uid = i + 1;
        obj.url = item.url;
        obj.format = item.format;
        obj.name = item.name;
        return obj;
      });
      this.previewListVisible = true;
    },
    // 预览处理
    async handlePreview(file, index) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.response.data.fileTempUrl || file.preview;
        if (index || index === 0) {
          this.currentPreviewIndex = this.claimsInfo.claimsDocument[index].documentUrl.indexOf(file);
          this.previewFileList = this.claimsInfo.claimsDocument[index].documentUrl;
        } else {
          this.currentPreviewIndex = this.additionalFileList.indexOf(file);
          this.previewFileList = this.additionalFileList;
        }
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        this.$message.warn(file.name.split('.')[1] + this.$t('文件暂不支持预览'));
        return;
      }
      this.previewVisible = true;
    },
    changeUpload({
      file,
      fileList
    }, index) {
      const isThanMax = file.size / 1024 / 1024 < 50;
      if (!isThanMax) {
        // this.$message.error('文件最大不超50M');
      } else {
        const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1).toLowerCase();
        const res = index || index === 0 ? this.claimsInfo.claimsDocument[index].documentFormat.indexOf(fileType) : this.plainOptions.indexOf(fileType);
        console.log(fileList, 222);
        let new_fileList = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              item.url = cryptoDecrypt(item.response.data) ? cryptoDecrypt(item.response.data).fileTempUrl : null;
            } else {
              item.url = item.response.data ? item.response.data.fileTempUrl : null;
            }
          }
          return item;
        });
        if (file.status == 'done') {
          const index2 = new_fileList.findIndex(item => !item.url);
          if (index2 > -1) {
            new_fileList.splice(index2, 1);
          }
        }
        if (res > -1) {
          if (index || index === 0) {
            /* eslint-disable */
            this.claimsInfo.claimsDocument[index].documentUrl = new_fileList;
          } else {
            this.additionalFileList = new_fileList;
          }
        } else {
          this.$message.error(this.$t('文件格式错误'));
        }
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    },
    selectArea(value, valueName, index, index2) {
      /* eslint-disable */
      this.claimsInfo.claimsSort[index].claimsParam[index2].paramPlaceholder = valueName;
    },
    async onSubmit() {
      let submitParams = recursionCopy(this.claimsInfo);
      submitParams.claimsSort.map(item => {
        // item.auditOpinion='';
        item.claimsParam.map(item2 => {
          // item2.auditOpinion='';
          delete item2.selectarr;
          return item2;
        });
        return item;
      });
      const claimsList = await claimsVerifyy({
        policyId: this.policyId,
        claimsTypeId: this.claimsInfo.claimsTypeId,
        claimsContent: JSON.stringify(submitParams.claimsSort)
      });
      /* eslint-disable */
      this.claimsInfo.claimsSort = claimsList.claimsContent.map((item, index) => {
        item.claimsParam.map((item2, index2) => {
          if (item2.paramType == 'dropDownBox' || item2.paramType == 'profession' || item2.paramType == 'dropDownBox(region.code)') {
            item2.selectarr = this.claimsInfo.claimsSort[index].claimsParam[index2].selectarr;
          }
          return item2;
        });
        return item;
      });
      if (claimsList.isError) {
        this.$message.error(this.$t('请先完善信息'));
        return false;
      }
      // const res = this.claimsInfo.claimsDocument.find(item => item.documentUrl.length === 0);
      // if (res) {
      //   this.$message.error('请先上传文件');
      //   return;
      // }
      let returnRes = true;
      // if (this.additionalFileList.length != 0) {

      let submitAdditionalParams = recursionCopy(this.additionalFileList);
      let itemObj = {
        documentId: 0,
        documentName: '补充文件',
        documentFormat: this.plainOptions,
        documentDescription: '',
        documentTemplateUrl: [],
        documentUrl: submitAdditionalParams,
        auditOpinion: ''
      };
      submitParams.claimsDocument.push(itemObj);
      // }
      submitParams.claimsDocument.map(item => {
        let templateUrl = item.documentTemplateUrl.map(item2 => {
          console.log(item2.url);
          return item2.url;
        });
        let uploadUrl = item.documentUrl.map(file => {
          return file.url;
        });
        console.log(templateUrl);
        // item.documentUrl.map(file => {
        //   if (file.status === 'done') {
        //     templateUrl.push(file.response ? file.response.data.fileTempUrl : file.url);
        //   }
        // });
        // item.auditOpinion='';
        item.documentTemplateUrl = templateUrl;
        item.documentUrl = uploadUrl;
      });
      if (!returnRes) {
        return;
      }
      await auditOperate({
        auditScheduleId: this.auditScheduleId,
        editableArea: JSON.stringify(submitParams),
        goBack: 2
      });
      this.$message.success(this.$t('提交成功'));
      this.$emit('perfectOk');
    }
  }
};